// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.mjs";
import * as RelayRouter__Utils from "rescript-relay-router/src/RelayRouter__Utils.mjs";
import * as RelayRouter__Bindings from "rescript-relay-router/src/RelayRouter__Bindings.mjs";
import * as RelayRouter__Internal from "rescript-relay-router/src/RelayRouter__Internal.mjs";

function parseQueryParams(queryParams) {
  return {
          redirectUrl: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "redirectUrl"), (function (value) {
                  return value;
                }))
        };
}

function makePrepareProps(environment, pathParams, queryParams, $$location) {
  return {
          environment: environment,
          location: $$location,
          redirectUrl: Core__Option.flatMap(RelayRouter__Bindings.QueryParams.getParamByKey(queryParams, "redirectUrl"), (function (value) {
                  return value;
                }))
        };
}

var Internal = {
  parseQueryParams: parseQueryParams,
  makePrepareProps: makePrepareProps
};

function applyQueryParams(queryParams, newParams) {
  RelayRouter__Bindings.QueryParams.setParamOpt(queryParams, "redirectUrl", Core__Option.map(newParams.redirectUrl, (function (redirectUrl) {
              return redirectUrl;
            })));
}

function useQueryParams() {
  var match = RelayRouter__Utils.useLocation();
  var search__ = match.search;
  var queryParams__ = React.useMemo((function () {
          return RelayRouter__Bindings.QueryParams.parse(search__);
        }), [search__]);
  var param = RelayRouter__Bindings.QueryParams.getParamByKey(queryParams__, "redirectUrl");
  var redirectUrl = React.useMemo((function () {
          return Core__Option.flatMap(param, (function (value) {
                        return value;
                      }));
        }), [param]);
  var currentQueryParams = React.useMemo((function () {
          return {
                  redirectUrl: redirectUrl
                };
        }), [search__]);
  return {
          queryParams: currentQueryParams,
          setParams: RelayRouter__Internal.useSetQueryParams(parseQueryParams, applyQueryParams)
        };
}

function makeLink(redirectUrl) {
  var queryParams = RelayRouter__Bindings.QueryParams.make();
  if (redirectUrl !== undefined) {
    RelayRouter__Bindings.QueryParams.setParam(queryParams, "redirectUrl", redirectUrl);
  }
  return RelayRouter__Bindings.generatePath("/login", Object.fromEntries([])) + RelayRouter__Bindings.QueryParams.toString(queryParams);
}

function makeLinkFromQueryParams(queryParams) {
  return makeLink(queryParams.redirectUrl);
}

function useMakeLinkWithPreservedPath() {
  return RelayRouter__Internal.useMakeLinkWithPreservedPath(parseQueryParams, applyQueryParams);
}

function isRouteActive($staropt$star, param) {
  var exact = $staropt$star !== undefined ? $staropt$star : false;
  return Core__Option.isSome(RelayRouter__Internal.matchPathWithOptions({
                  path: "/login",
                  end: exact
                }, param.pathname));
}

function useIsRouteActive(exactOpt) {
  var exact = exactOpt !== undefined ? exactOpt : false;
  var $$location = RelayRouter__Utils.useLocation();
  return React.useMemo((function () {
                return isRouteActive(exact, $$location);
              }), [
              $$location,
              exact
            ]);
}

var parseRoute = RelayRouter__Internal.parseRoute({
      TAG: "QueryParams",
      routePattern: "/login",
      parseQueryParams: parseQueryParams
    });

export {
  Internal ,
  applyQueryParams ,
  useQueryParams ,
  makeLink ,
  makeLinkFromQueryParams ,
  useMakeLinkWithPreservedPath ,
  isRouteActive ,
  useIsRouteActive ,
  parseRoute ,
}
/* parseRoute Not a pure module */
